// extracted by mini-css-extract-plugin
export var productImage = "_xk-0";